module.exports = function ($el) {
    $el.modaal('close');
};